module.exports = __webpack_public_path__ + "img/gb9113_10_a.prt.aa5cf4e3.jpg";